<template>
  <div
    class="right_body action_body"
    v-loading="isLoading"
    :element-loading-background="loadingBg"
    :element-loading-text="loadingTxt"
  >
    <span class="btn right_sub_btn add_btn" style="margin-right:120px" @click.stop="subCheck">订单释放</span>
    <span class="btn right_sub_btn save_btn" @click.stop="subSave">提交数据</span>
    <div class="active_rumb">
      <span class="txt">生产订单</span>
    </div>

    <div class="coll header_box">
      <h2 class="title">
        <span>抬头信息</span>
      </h2>
      <v-head
        :fromData="fromData"
        :noFromData="noFromData"
        :factoryList="this.$store.state.cache.factoryList"
      ></v-head>
    </div>

    <div class="coll list_content">
      <el-tabs v-model="activeName2" type="border-card" @tab-click="handleClick">
        <el-tab-pane label="明细信息" name="first">
          <v-list :fromData="fromData" :noFromData="noFromData" ref="vList"></v-list>
        </el-tab-pane>
        <el-tab-pane label="BOM信息" name="second">
          <v-bom-list :fromData="fromData" :noFromData="noFromData" ref="bomList"></v-bom-list>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { factoryApi } from "api/base.js";
import { productOrder } from "api/business.js";
import { company } from "api/system.js";
import vHead from "./components/orderNew/head.vue";
import VBomList from "./components/orderNew/bomList.vue";
import vList from "./components/orderNew/list.vue";

import { mapState, mapActions } from "vuex";
export default {
  components: {
    vHead,
    VBomList,
    vList
  },
  data() {
    return {
      defaultValue: 0,
      activeName2: "first",
      textarea: "",
      isLoading: true,
      loadingBg: "rgba(255,255,255,1)",
      loadingTxt: "加载中",
      id: "",
      isChildComponent: false,
      //需要提交的数据
      fromData: {
        unitId: "",
        delId: false,
        autoGr: false,
        disabledStatus: true,
        changeDisaStatus: false,
        orderStates: "0001",
        orderType: "pp02",
        productOrderNo: "",
        bomDto: {},
        salesOrderDtlDto: {},
        details: []
      },
      //不需要提交的数据
      noFromData: {}
    };
  },
  //设置校验规则
  vuerify: {
    "fromData.voucherDate": [
      "required" //必填项
      /* {
				test (val) {
					return /\d{4}-\d{1,2}-\d{1,2}/.test(val) && Date.parse(val)
				},
				message: '日期格式不正确 yyyy-mm-dd'
			}, */
    ]
  },
  computed: {
    errors() {
      return this.$vuerify.$errors;
    }
  },
  watch: {
    fromData: function(val, old) {
      console.log(val, old);
    }
  },
  created() {
    //请求初始数据
    this.getStartData();
    let changeStatus = this.$route.params.changeStatus;
    console.log(changeStatus);
  },
  methods: {
    async handleClick(tab) {
      console.log(tab);
      if (tab.paneName == "second") {
        console.log(this.fromData);
        this.isLoading = true;
        this.loadingBg = "rgba(255,255,255,0.5)";
        this.loadingTxt = "数据加载中...";
        let res = await this.$post(productOrder.bomList, this.fromData);
        let json = JSON.stringify(this.fromData);
        console.log(json);
        this.isLoading = false;
        if (res.status) {
          console.log(res);
          this.$store.state.cache.selectedMatterProductOrders =
            res.data.bomDto.bomComponents;
        } else {
          this.$message.error(res.errorMsg + "，请先添加抬头信息和明细信息！");
        }
      }
    },
    ...mapActions("cache", ["clearCache"]),
    //关闭弹窗
    handleClose() {},
    //需要请求的初始数据
    async getStartData() {
      //console.log(this.$store.state.cache.customerList,'==444==');
      //工厂列表
      if (!this.$store.state.cache.factoryList) {
        let factoryList = await this.$post(
          factoryApi.list,
          this.$store.state.getAllPage
        );
        if (factoryList.status) {
          factoryList.data.list.forEach(item => {
            item.value = item.factoryCode + "-" + item.factoryDesc;
          });
          this.$store.state.cache.factoryList = factoryList.data.list;
        } else {
          this.$store.state.cache.factoryList = null;
        }
      }

      //初始化数据
      if (this.$route.params.changeStatus) {
        console.log(this.$store.state.cache.detailData);
        this.fromData = this.$store.state.cache.detailData;
        this.fromData.salesOrderDtlDto = this.$store.state.cache.detailData.details[0];
        this.fromData.orderType = "pp03";
        this.fromData.factoryStr = this.$store.state.cache.detailData.details[0].factoryDesc;
        this.fromData.factoryId = this.$store.state.cache.detailData.details[0].factoryId;
        this.fromData.factoryCode = this.$store.state.cache.detailData.details[0].factoryCode;
        this.fromData.factoryDesc = this.$store.state.cache.detailData.details[0].factoryDesc;
        this.fromData.inventoryId = this.$store.state.cache.detailData.details[0].inventoryId;
        this.fromData.inventoryCode = this.$store.state.cache.detailData.details[0].inventoryCode;
        this.fromData.inventoryDesc = this.$store.state.cache.detailData.details[0].inventoryDesc;
        this.fromData.materialId = this.$store.state.cache.detailData.details[0].materialId;
        this.fromData.materialCode = this.$store.state.cache.detailData.details[0].materialCode;
        this.fromData.materialDesc = this.$store.state.cache.detailData.details[0].materialDesc;
        this.fromData.orderQuantityTotal = this.$store.state.cache.detailData.details[0].targetNum;
        this.fromData.entryUnitId = this.$store.state.cache.detailData.details[0].basicUnitId;
        this.fromData.entryUnitCode = this.$store.state.cache.detailData.details[0].basicUnitCode;
        this.fromData.entryUnitDesc = this.$store.state.cache.detailData.details[0].basicUnitDesc;
        // this.fromData.orderConfirmScrap = this.defaultValue
        // this.fromData.batchCharacter = this.fromData.orderConfirmScrap / this.fromData.orderQuantityTotal * 100
        this.fromData.changeDisaStatus = true;
        this.fromData.disabledStatus = true;
      }
      this.isLoading = false;
    },

    //保存提交数据
    async subSave() {
      let vm = this;
      if (!this.fromData.factoryStr) {
        this.$message.error("请选择工厂");
        return false;
      }
      if (!this.fromData.inventoryId) {
        this.$message.error("请选择库存地点");
        return false;
      }
      if (!this.fromData.orderType) {
        this.$message.error("请选择订单类型");
        return false;
      }
      if (!this.fromData.materialCode) {
        this.$message.error("请选择物料编码");
        return false;
      }
      if (!this.fromData.materialDesc) {
        this.$message.error("请选择物料描述");
        return false;
      }
      if (!this.fromData.optionBom) {
        this.$message.error("请选择BOM版本");
        return false;
      }
      if (!this.fromData.orderStates) {
        this.$message.error("请选择订单状态");
        return false;
      }
      if (
        !this.fromData.orderQuantityTotal ||
        !this.fromData.orderConfirmScrap ||
        !this.fromData.deliveryQty
      ) {
        this.$message.error("请补全明细信息");
        return false;
      }
      if (!this.fromData.orderStartDate) {
        this.$message.error("请选择基本开始日期");
        return false;
      }
      if (!this.fromData.basicCompletionDate) {
        this.$message.error("请选择基本结束日期");
        return false;
      }

      let changeStatus = this.$route.params.changeStatus;
      var postUrl = productOrder.add;
      if (changeStatus) postUrl = productOrder.turn;
      this.fromData.details = [];
      if (this.fromData.autoGr == true) {
        this.fromData.autoGr = "1";
      } else {
        this.fromData.autoGr = "";
      }
      if (this.fromData.delId == true) {
        this.fromData.delId = "1";
      } else {
        this.fromData.delId = "";
      }
      console.log(this.fromData.unitId);
      if (this.fromData.unitId != "") {
        this.fromData.entryUnitId = this.fromData.unitId;
        this.fromData.entryUnitCode = this.fromData.unitCode;
        this.fromData.entryUnitDesc = this.fromData.unitDesc;
      }
      this.fromData.bomDto.bomComponents = this.$store.state.cache.selectedMatterProductOrders;
      this.fromData.orderStartDate = this.$moment(
        this.fromData.orderStartDate
      ).format("YYYY-MM-DD");
      this.fromData.actualStartDate = this.$moment(
        this.fromData.actualStartDate
      ).format("YYYY-MM-DD");
      this.fromData.basicCompletionDate = this.$moment(
        this.fromData.basicCompletionDate
      ).format("YYYY-MM-DD");
      this.fromData.determineCompleteDate = this.$moment(
        this.fromData.determineCompleteDate
      ).format("YYYY-MM-DD");
      this.fromData.actualReleaseDate = this.$moment(
        this.fromData.actualReleaseDate
      ).format("YYYY-MM-DD");
      console.log(this.fromData, "=====测试数据======");
      this.isLoading = true;
      this.loadingBg = "rgba(255,255,255,0.5)";
      this.loadingTxt = "数据处理中...";
      //隐藏提交按钮，防止重复提交
      $(".save_btn").hide();
      $(".add_btn").hide();
      let res = await this.$post(postUrl, this.fromData);
      let json = JSON.stringify(this.fromData);
      console.log(json);
      this.isLoading = false;
      if (res.status) {
        console.log(res);
        this.fromData.productOrderNo = res.data.productOrderNo;
        this.$store.state.cache.selectedMatterProductOrder = res.data.details;
        this.$confirm(
          "生产订单 " + res.data.productOrderNo + " 被创建",
          "提示",
          {
            confirmButtonText: "继续",
            cancelButtonText: "退出",
            type: "success"
          }
        )
          .then(() => {
            // vm.$router.push({ name: "business-production-orderNew" });
            this.$keepAliveManager.backSourceRoute(this,{name: 'business-production-orderNew'});
            //清除部分缓存数据
            vm.clearCache();   
          })
          .catch(() => {
            this.$keepAliveManager.backSourceRoute(this,{name: 'home'});
            // vm.$router.push({ name: "home" });
            this.fromData = {};
            vm.$store.state.cache.selectedMatterProductOrder = [];
            //清除部分缓存数据
            vm.clearCache();
          });
      } else {
        this.$message.error(res.errorMsg);
        //提交失败后显示提交按钮
        $(".save_btn").show();
        $(".add_btn").show();
      }
    },

    //订单释放（修改订单）
    async subCheck() {
      if (!this.fromData.factoryStr) {
        this.$message.error("请选择工厂");
        return false;
      }
      if (!this.fromData.inventoryId) {
        this.$message.error("请选择库存地点");
        return false;
      }
      if (!this.fromData.orderType) {
        this.$message.error("请选择订单类型");
        return false;
      }
      if (!this.fromData.materialCode) {
        this.$message.error("请选择物料编码");
        return false;
      }
      if (!this.fromData.materialDesc) {
        this.$message.error("请选择物料描述");
        return false;
      }
      if (!this.fromData.optionBom) {
        this.$message.error("请选择BOM版本");
        return false;
      }
      // if (!this.fromData.orderQuantityTotal || !this.fromData.orderConfirmScrap || !this.fromData.deliveryQty || !this.fromData.nachl) {
      //   this.$message.error("请补全明细信息");
      //   return false;
      // }
      if (!this.fromData.productOrderNo) {
        this.fromData.orderStates = "0002";
        this.$message.success("订单释放成功，请继续提交数据");
        return false;
      } else if (this.fromData.orderStates == "0001") {
        //调用释放方法
        //console.log(this.$store.state.cache.selectedMatterProductOrders[0].componentNum)
        this.fromData.details = [];
        this.fromData.details = this.$store.state.cache.selectedMatterProductOrder;
        //this.fromData.bomDto.bomComponents[0].componentNum = this.$store.state.cache.selectedMatterProductOrders[0].componentNum
        console.log(this.fromData, "=====测试数据======");
        this.isLoading = true;
        this.loadingBg = "rgba(255,255,255,0.5)";
        this.loadingTxt = "数据处理中...";
        //隐藏提交按钮，防止重复提交
        $(".save_btn").hide();
        $(".add_btn").hide();
        let res = await this.$post(productOrder.edit, this.fromData);
        let json = JSON.stringify(this.fromData);
        console.log(json);
        this.isLoading = false;
        if (res.status) {
          console.log(res);
          this.fromData.productOrderNo = res.data.productOrderNo;
          //按钮绿色
          this.fromData.orderStates = "0002";
          this.$message.success(
            "生产订单号" + res.data.productOrderNo + "释放成功，请继续操作"
          );
        } else {
          this.$message.error(res.errorMsg);
        }
      } else {
        //按钮灰色
        this.$message.error("该订单已释放过，禁止再次释放订单！");
        //提交失败后显示提交按钮
        $(".save_btn").show();
        $(".add_btn").show();
      }
    }
  }
};
</script>

<style lang="stylus" scoped></style>
